import { computed } from 'vue'
import { useStore } from 'vuex'

export function useAuth() {
  const store = useStore()

  const isPending = computed(() => store.state.auth.pending)
  const isLoggedIn = computed(() => store.state.auth.isAuthenticated)
  const isReady = computed(() => isLoggedIn.value && !isPending.value)

  return {
    isLoggedIn,
    isPending,
    isReady,
  }
}
